import { CancelTokenSource } from 'axios';
import { UpsertUserRequestDto, UpsertUserSettingsDto, UserDisplayDto, UserSettingsDto } from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/users`;

export const getUserDisplay = (
    source: CancelTokenSource): Promise<UserDisplayDto> => {

  return axios
      .get(`${apiUri}/user/display`, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchUsers = (userSearchTerm: String,
                            source: CancelTokenSource): Promise<Array<UserSettingsDto>> => {
  return axios
      .get(`${apiUri}`, {params: {query: userSearchTerm}, cancelToken: source.token})
      .then(response => response.data)
};

export const getAllUsers = (source: CancelTokenSource): Promise<Array<UserSettingsDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
};

export const findUserById = (request: Partial<UpsertUserRequestDto>, source: CancelTokenSource): Promise<UpsertUserSettingsDto> => {
  return axios
      .post(`${apiUri}/user`, request, {cancelToken: source.token})
      .then(response => response.data)
};

export const deleteUser = (id: number, source: CancelTokenSource): Promise<UserSettingsDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addUser = (
    upsertUserSettingsDto: Partial<UpsertUserSettingsDto>,
    file: any,
    source: CancelTokenSource): Promise<UserSettingsDto> => {

  const requestJsonString = JSON.stringify(upsertUserSettingsDto);
  const blob = new Blob([requestJsonString], {
    type: 'application/json'
  });

  const formData = new FormData();
  formData.append("requestDto", blob);
  formData.append("file", file);

  return axios
      .post(apiUri, formData, {cancelToken: source.token})
      .then(response => response.data);
};

export const editUser = (
    id: number,
    upsertUserSettingsDto: Partial<UpsertUserSettingsDto>,
    file: any,
    source: CancelTokenSource): Promise<UserSettingsDto> => {

  const requestJsonString = JSON.stringify(upsertUserSettingsDto);
  const blob = new Blob([requestJsonString], {
    type: 'application/json'
  });

  const formData = new FormData();
  formData.append("requestDto", blob);
  formData.append("file", file);

  return axios
      .post(`${apiUri}/${id}`, formData, {cancelToken: source.token})
      .then(response => response.data);
};
